import { setTileView } from "./actions";

export function RPC_LayoutMiddleware(store, result, action) {
    switch (action.type) {
        case 'DATA_CHANNEL_OPENED': {
            store.dispatch(setTileView(true));
            break;
        }
    }
    
    return result;
}